(function() {
    angular
        .module("apiModule")
        .controller("ApiController", ApiController)

    ApiController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$uibModal",
        "apiService"
    ]

    function ApiController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $uibModal,
        apiService
    ){
        "use strict"

        if (!$rootScope.can('ApiGeneralRead', $stateParams.customer_id)) {
            $state.go("devices")
        }

        $rootScope.title = "API | WANCO"

        $scope.canEditKeys      = false
        $scope.apiKeysLoaded    = false
        $scope.wzdxConfigLoaded = false

        $scope.apiKeys = {
            production: {},
            test:       {},
            deprecated: []
        }

        $scope.wzdxConfig = {}

        const validateCanEditKeys = () => {
            $scope.canEditKeys = $rootScope.can('ApiKeyCreate', $stateParams.customer_id)
        }

        validateCanEditKeys()

        const setAPIKeys = (data) => {

            $scope.apiKeys = {
                production: {},
                test:       {},
                deprecated: []
            }

            if (data) {

                if (data.hasOwnProperty("version")) {
                    $scope.apiKeys.version = data.version
                }

                if (data.hasOwnProperty("production")) {
                    $scope.apiKeys.production = data.production
                }

                if (data.hasOwnProperty("test")) {
                    $scope.apiKeys.test = data.test
                }

                if (data.hasOwnProperty("deprecated")) {
                    $scope.apiKeys.deprecated = data.deprecated
                }
            }

            if ($scope.apiKeys.production.hasOwnProperty("key")) {
                $uibModal.open({
                    templateUrl: "app/modals/show-api-key-modal.view.html",
                    controller:  "ShowApiKeyModalController",
                    resolve: {
                        key: function() {
                            return $scope.apiKeys.production.key
                        }
                    }
                }).result.catch(function(res) {
                    $scope.apiKeys.production.key = undefined
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        const setWZDxConfig = (data) => {

            $scope.wzdxConfig = {}

            if (data) {

                if (data.hasOwnProperty("username")) {
                    $scope.wzdxConfig.username = data.username
                }

                if (data.hasOwnProperty("update_frequency")) {
                    $scope.wzdxConfig.update_frequency = data.update_frequency
                }

                if (data.hasOwnProperty("dot_geo_iso")) {
                    $scope.wzdxConfig.dot_geo_iso = data.dot_geo_iso
                }

                if (data.hasOwnProperty("url")) {
                    $scope.wzdxConfig.url = data.url
                }

                if (data.hasOwnProperty("password_masked")) {
                    $scope.wzdxConfig.password_masked = data.password_masked
                }

                if (data.hasOwnProperty("password")) {
                    $scope.wzdxConfig.password = data.password
                }
            }

            if ($scope.wzdxConfig.hasOwnProperty("password")) {
                $uibModal.open({
                    templateUrl: "app/modals/show-wzdx-password-modal.view.html",
                    controller:  "ShowWZDxPasswordModalController",
                    resolve: {
                        password: function() {
                            return $scope.wzdxConfig.password
                        }
                    }
                }).result.catch(function(res) {
                    $scope.wzdxConfig.password = undefined
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        const getData = () => {

            if (!$scope.apiKeysLoaded && $rootScope.apiConfigID) {

                apiService.getAPIKeys($stateParams.customer_id, $rootScope.apiConfigID, (data) => {
                    setAPIKeys(data)
                    $scope.apiKeysLoaded = true
                })
            }

            if (!$scope.wzdxConfigLoaded && $rootScope.wzdxConfigID) {

                apiService.getWZDxConfig($stateParams.customer_id, $rootScope.wzdxConfigID, (data) => {
                    setWZDxConfig(data)
                    $scope.wzdxConfigLoaded = true
                })
            }
        }

        getData()

        $scope.generateAPIKey = function(asTest) {

            apiService.generateAPIKey($stateParams.customer_id, $rootScope.apiConfigID, asTest, function(data) {
                gtag("event", "create_api_key", { customer_id: $stateParams.customer_id, type: asTest ? "TEST" : "PRODUCTION" })
                setAPIKeys(data)
            })
        }

        $scope.deleteAPIKey = function(apiKeyID) {

            apiService.deleteAPIKey($stateParams.customer_id, $rootScope.apiConfigID, apiKeyID, function(data) {
                gtag("event", "delete_api_key", { customer_id: $stateParams.customer_id, deprecate: !!$scope.apiKeys.production && $scope.apiKeys.production.id == apiKeyID, type: ($scope.apiKeys.test && $scope.apiKeys.test.id == apiKeyID) ? "TEST" : "PRODUCTION" })
                setAPIKeys(data)
            })
        }

        $scope.generateWZDxPassword = function() {

            apiService.generateWZDxPassword($stateParams.customer_id, $rootScope.wzdxConfigID, function(data) {
                setWZDxConfig(data)
            })
        }

        $scope.deleteWZDxPassword = function() {

            const performAction = () => {
                apiService.deleteWZDxPassword($stateParams.customer_id, $rootScope.wzdxConfigID, function(data) {
                    setWZDxConfig(data)
                })
            }

            $uibModal.open({
                templateUrl: "app/modals/generic-confirmation-modal.view.html",
                controller: "GenericConfirmationModalController",
                resolve: {
                    title: () => {
                        return "Confirm Delete WZDx Flat File Password"
                    },
                    question: () => {
                        return "Are you sure you want to delete the WZDx Flat File password?"
                    },
                    warning: () => {
                        return "Once the password is deleted it will no longer function and is not recoverable."
                    },
                    buttonLabel: () => {
                        return "Delete"
                    },
                    performAction: () => {
                        return performAction
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.$watch("$root.is_authenticated", () => {

            if ($rootScope.is_authenticated) {
                validateCanEditKeys()
            }
        })

        $scope.$watch("$root.customers", () => {

            if ($rootScope.customers && $rootScope.customers.length > 0) {
                if (!$scope.apiKeysLoaded || !$scope.wzdxConfigLoaded) {
                    setTimeout(() => {
                        getData()
                    }, 100)
                }
            }
        })
    }
})()
